<template>
  <div
    class="alert alert-info alert-dismissable"
    role="alert"
  >
    <button
      type="button"
      class="close"
      data-dismiss="alert"
      aria-label="Закрыть"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    Старая версия личного кабинета доступна по адресу: <a
      :href="'https://' + to"
      v-text="to"
    />
  </div>
</template>

<script>

export default {
  name: 'CabinetOld',
  props: {
    to: {
      type: String,
      required: true
    }
  }
}
</script>
